import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppStateService } from '../service/app-state.service';
import { StorageService } from '../service/storage.service';
import { ApiService } from '../api.service';
import { AuthService, TokenResponse } from '../service/auth.service';
import { NavigationService } from '../service/navigation.service';
import { Environment } from '../../typings';
import { EnvironmentToken } from '../../util';

@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginPageComponent implements OnInit {
  reset = false;

  returnTo: string | null = null;
  position: string | null = null;
  registered = false;

  submitted = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private stateService: AppStateService,
    private storageService: StorageService,
    private apiService: ApiService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    @Inject(EnvironmentToken) private environment: Environment
  ) {
    this.route.queryParams.subscribe(params => {
      this.returnTo = params['returnTo'] || null;
      this.position = params['position'] || null;
      this.reset = !!params['reset'];
      this.registered = !!params['registered'];
    });
  }

  ngOnInit() {
    if (this.authService.isFullyAuthenticated()) {
      this.stateService.loading$.next(true);
      this.postAuthentication();
    } else {
      this.stateService.loading$.next(true);
      const url = window.location;
      const baseUrl = `${url.protocol}//${url.host}`;
      window.location.href = `${this.environment.matHost}/myaquent?PROC=AWUIDrawMatLogin&redirectUrl=${baseUrl}${this.returnTo}`;
    }
  }

  private postAuthentication() {
    if (this.returnTo) {
      void this.router.navigateByUrl(this.returnTo);
    } else {
      void this.navigationService.goHome();
    }
  }
}
